import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { newsService } from '@/services/news.service';

interface NewsState {
  unreadCount: number;
  loading: boolean;
}

const initialState: NewsState = {
  unreadCount: 0,
  loading: false,
};

export const markAllNewsAsRead = createAsyncThunk(
  'news/markAllAsRead',
  async () => {
    await newsService.markAllAsRead();
    return 0;
  }
);

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    decrementUnreadCount: (state) => {
      if (state.unreadCount > 0) {
        state.unreadCount -= 1;
      }
    },
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(markAllNewsAsRead.fulfilled, (state) => {
        state.unreadCount = 0;
      });
  },
});

export const { decrementUnreadCount, setUnreadCount } = newsSlice.actions;
export default newsSlice.reducer;
